import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Tr,
} from "@chakra-ui/react";
import { FiEye, FiSearch, FiTrash } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import { get_purchase_list } from "../../redux/purchaseSlice";
import { baseUrl, formatIndianPrice } from "../../utils/utils";

const Purchase = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const { purchase_list, total_purchase_count } = useSelector(
    (state) => state.purchase
  );

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `purchase.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result);
      if (result?.success) {
        store.dispatch(get_purchase_list({ page: page, rows: rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error("Failed to load product data", {
        position: "top-right",
        autoClose: 5000,
      });
      navigate("/products");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    store.dispatch(get_purchase_list({ page: page, rows: rows }));
  }, []);
  return (
    <>
      <Card
        bg="#fff"
        p={2}
        display="flex"
        flexDirection={["column", "row"]}
        alignItems={["stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <InputGroup
          bg="#f4f5f7"
          borderRadius={5}
          w={["100%", "auto"]}
          maxW="sm"
        >
          <Input placeholder="Search..." />
          <InputRightElement>
            <FiSearch />
          </InputRightElement>
        </InputGroup>

        <Spacer display={["none", "block"]} />

        <Flex w={["100%", "auto"]} justifyContent={["start", "flex-end"]}>
          <CustomButton
            title="Add Purchase"
            w={["100%", ""]}
            onClick={() =>
              navigate("/purchase/add-purchase", {
                state: { purchase_list: purchase_list },
              })
            }
          />
        </Flex>
      </Card>

      <div>
        <TableView
          headData={[
            "S.No.",
            "Invoice no",
            "vendor id",
            "total amount",
            "invoice date",
            "products",
            "Action",
          ]}
          body={purchase_list?.map((el, i) => (
            <Tr>
              <Td textAlign="center">{i + initialValue}</Td>
              <Td textAlign="center">{el.inv_no}</Td>
              <Td textAlign="center">{el.vendor_name}</Td>
              <Td textAlign="center">{formatIndianPrice(el.total_amount)}</Td>
              <Td textAlign="center">{el.inv_date}</Td>
              <Td textAlign="center">{el.details?.length}</Td>

              <Td textAlign="center">
                {
                  <Flex justify={"center"} gap={4}>
                    <CustomToolTip
                      button={
                        <FiEye
                          size={20}
                          cursor={"pointer"}
                          onClick={() =>
                            navigate(`/purchase/detail/${el.id}`, {
                              state: el,
                            })
                          }
                        />
                      }
                      mess={"View Product"}
                    />
                    {/* <CustomToolTip
                      button={
                        <FiTrash
                          size={20}
                          cursor={"pointer"}
                          color="#F00"
                          onClick={() => {
                            setDeleteId(el.id);
                            setDeleteDialog(true);
                          }}
                        />
                      }
                      mess={"Delete Product"}
                    /> */}
                  </Flex>
                }
              </Td>
            </Tr>
          ))}
          initialValue={initialValue}
          page={page}
          rows={rows}
          total_value={total_purchase_count}
          pagination
          onChange={(e) => {
            setInitialValue(1);
            setpage(1);
            console.log("e.target.value", page);
            store.dispatch(
              get_purchase_list({ page: 1, rows: e.target.value })
            );
            setRows(e.target.value);
          }}
          onPrevious={() => {
            initialValue == 1 ||
              setInitialValue(Number(initialValue) - Number(rows));
            page == 1 || setpage(page - 1);
            page === 1 ||
              store.dispatch(get_purchase_list({ page: page - 1, rows: rows }));
          }}
          onNext={() => {
            rows * page >= total_purchase_count ||
              setInitialValue(Number(initialValue) + Number(rows));
            rows * page >= total_purchase_count || setpage(page + 1);
            rows * page >= total_purchase_count ||
              store.dispatch(get_purchase_list({ page: page + 1, rows: rows }));
          }}
        />
        <ConfirmDialog
          isOpen={deleteDialog}
          onClose={() => setDeleteDialog(false)}
          onConfirm={handleDelete}
          type="delete"
          title="Delete purchase"
          message="Are you sure you want to delete this purchase? This action cannot be undone and will remove all associated data."
          confirmText="Delete"
          cancelText="Cancel"
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default Purchase;
